import React from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { strings } from '../../../resources/strings';
import { useAuth } from '../../../contexts/AuthContext';
import ServicesContext from '../../../contexts/ServicesContext';
import { GetNewDnpLinkInput } from '../../../services/DnpLinks/GetNewDnpLink/GetNewDnpLinkInput';
import { ContainerBody, Row } from './styles';

interface IModalNewDnpLinkProps {
    close: () => void;
}

const ModalNewDnpLink: React.FC<IModalNewDnpLinkProps> = ({
    close
}) => {

    const [ expirationDate, setExpirationDate ] = React.useState<Date|null>(null);

    const { session } = useAuth();

    const {
        getNewDnpLinkService,
        toastService
    } = React.useContext(ServicesContext);

    return (
        <Modal
            show={true}
            onHide={() => close()}
            backdrop="static"
            keyboard={false}
            
        >
            <Modal.Header>
                <Modal.Title>
                    Obter Novo Link
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{maxHeight:'78vh'}}>
                <ContainerBody>
                    <Row>
                        <Field
                            type={FieldType.DateTimePicker}
                            label={strings.DateExpiration}
                            value={expirationDate}
                            change={(value) => setExpirationDate(value)}
                            marginTop={'0px'}
                        />
                    </Row>
                </ContainerBody>
            </Modal.Body>
            <Modal.Footer>
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} />
                    <Button text={strings.Confirm} click={() => newDnpLink()}  marginLeft={'10px'} />
                </div>
            </Modal.Footer>
        </Modal>
    );

    function newDnpLink() {
        const userName = session?.user?.name;

        if (!userName) return;

        if (!expirationDate) {
            toastService.warning('Informe a data de expiração do novo link!');
            return;
        }

        const input = new GetNewDnpLinkInput();
        input.requesterName = userName;
        input.expirationDate = moment(expirationDate).format('YYYY-MM-DDTHH:mm:ss');

        getNewDnpLinkService.handle(input).then(result => {
            const messages = result?.value?.messages || [];
            if (messages.length > 0) {
                messages.forEach(message => toastService.warning(message));
                return;
            }
            
            const dnpLinkId = result?.value?.dnpLink?.id;
            if (!dnpLinkId) {
                toastService.warning('Não consegui gerar o novo link. Tente novamente e se o problema persistir avise o time Tech.');
                return;
            }

            toastService.success('Novo link gerado com sucesso!');

            setExpirationDate(null);

            close();
        });
    }
}

export {ModalNewDnpLink};